module.exports = __webpack_public_path__ + "static/media/02-2-galeria-04-perisur-mobile@2x.2f4080eb.jpg";